<template>
  <div>
    <a-modal
      :title="fileType === 'image' ? language['system.file.upload'] : language['system.file.upload']"
      :width="width"
      :visible="visible"
      @ok="ok"
      :cancelText="language['common.cancel']"
      @cancel="close">
      <!--style="top: 20px;"-->
      <L-upload :file-type="fileType" v-model="fileList" :uploadSource="uploadSource" @change="handleChange" :buttonVisible="!disabled"  :disabled="disabled" :multiple="multiple"></L-upload>
    </a-modal>
  </div>
</template>

<script>
  import { getFileAccessHttpUrl } from '@/api/manage';
  import LUpload from '@/components/jeecg/LUpload'
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }

  export default {
    name: 'LFilePop',
    components: { LUpload },
    props:{
      title:{
        type:String,
        default:'',
        required:false
      },
      position:{
        type:String,
        default:'right',
        required:false
      },
      height:{
        type:Number,
        default:200,
        required:false
      },
      uploadSource:{
        type: String,
        required: false,
        default: "platform"
      },
      width:{
        type:Number,
        default:520,
        required:false
      },
      multiple:{
        type: Boolean,
        default: false
      },
      popContainer:{
        type:String,
        default:'',
        required:false
      },
      disabled:{
        type:Boolean,
        default:false,
        required:false
      },
      number:{
        type:Number,
        required:false,
        default: 0
      }
    },
    data(){
      return {
        visible:false,
        fileList:[],
        filePath:[],
        id:'',
        fileType:'file'

      }
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
    },
    methods:{
      handleChange(){
        this.filePath = this.fileList;
      },
      show(id,value,flag,uploadSource){
        this.id = id;
        this.fileList = value;
        this.filePath = value;
        this.visible=true
        if(flag === 'img'){
          this.fileType = 'image'
        }else{
          this.fileType = 'file'
        }

      },
      ok(){
        if(!this.filePath){
          this.$message.error(this.language['selectFile'])
          return false;
        }
        //let arr = this.filePath.split(",")
        let obj = {
          //name:getFileName(this.filePath[0]),
          //url:getFileAccessHttpUrl(this.filePath[0]),
          path:this.filePath,
          status: 'done',
          id:this.id
        }
        this.$emit('ok',obj)
        this.visible=false
      },
      close(){
        this.visible=false
      }
    }
  }
</script>

<style scoped>

</style>